import styled from "styled-components";
//
// /* this shouldn't need any padding, if there are special layout considerations, that belongs elsewhere
// /* padding-top: ${({clientContext}) => (clientContext.isAmp === true ? "0" : "56.25%")}; */

const StyledGridLayout = styled.div``;

const StyledMobileGridLayout = styled.div``;

const StyledGridColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
`;

const StyledGridRow = styled.div`
  display: flex;
  flex-direction: row;
`;

export {
  StyledGridLayout,
  StyledMobileGridLayout,
  StyledGridColumn,
  StyledGridRow,
};
